import React from "react";
import { FaUser } from "react-icons/fa";
import styled from "styled-components";

const UserAvatar = () => {
  return (
    <UserMain>
      <FaUser className="user" />
    </UserMain>
  );
};

export default UserAvatar;

const UserMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background-color: rgb(32, 32, 79);
  border-radius: 50%;
  cursor: pointer;
  margin-right: 7px;

  .user {
    color: #fff;
  }
`;
